import React from 'react';
import { SimpleFlexbox } from 'ctm-components';
import { pageContext } from 'ctm-util-functions';
import { useStyles } from './quotesexpired_startnewquote_styles';
import { MechaButton } from '../mecha_components/mecha_button/mecha_button';

const QuotesExpiredStartNewQuote = (props) => {
    const isXs = pageContext.getProps().pageState.breakpoint === 'xs';
    const classes = useStyles({ isXs });
    const onStartNewQuoteClicked = (event) => {
        event.preventDefault();
        pageContext.getProps().browserHistory.push('/car-insurance/journey/start');
    };

    return (
        <form className={classes.formWrapper} data-id={'quotesexpired_startnewquote'}>
            <SimpleFlexbox className={classes.expiredquotes_startnewquote_container}>
                <div className={classes.expiredquotes_startnewquote_button_wrapper}>
                    <MechaButton
                        dataId={'expiresquotes_new_quote_button'}
                        buttonLabel="Start a new quote"
                        buttonSize="lg"
                        buttonType="white_hero"
                        onClick={onStartNewQuoteClicked}
                    />
                </div>
            </SimpleFlexbox>
        </form>
    );
};

export { QuotesExpiredStartNewQuote };
